import React from "react";

export default function BuildingBookAssetGeneral(
{
    asset
})
{
    return (

        <div>

            <FormRow
                label="Asset Code"
                value={asset.code}
            />

            <FormRow
                label="Asset Name"
                value={asset.name}
            />

            <FormRow
                label="Asset Type"
                value="Air Handling Unit"
            />

            <FormRow
                label="Manufacturer"
                value="Daikin"
            />

            <FormRow
                label="Model"
                value="AHU-2500"
            />

            <FormRow
                label="Serial Number"
                value="SN-123456"
            />

            <FormRow
                label="Location"
                value="Plant Room 01"
            />

            <FormRow
                label="Install Date"
                value="12/06/2018"
            />

            <FormRow
                label="Expected Replacement"
                value="12/06/2033"
            />

            <FormRow
                label="Status"
                value="Operational"
            />

        </div>

    );
}

function FormRow(
{
    label,
    value
})
{
    return (

        <div style={row}>

            <div style={labelStyle}>
                {label}
            </div>

            <input
                style={input}
                defaultValue={value}
            />

        </div>

    );
}

const row =
{
    marginBottom: "20px",
	marginLeft:'10px'
};

const labelStyle =
{
    fontWeight: "600",

    marginBottom: "8px",

    color: "#444"
};

const input =
{
    width: "calc(100% - 40px)",

    padding: "12px",

    border:
        "1px solid #d9dde2",

    borderRadius: "8px",

    fontSize: "14px",

    background: "#ffffff"
};
